import { Minus, Plus } from 'react-feather';

const IRSUnit = ({
    plusClass, minusClass, modifiers, incrementFunc, decrementFunc, disabled = false
}) => (
    <>
        {modifiers.map(([addValue, minusValue], i) => <div key={`modifier-${i}`} className='space-y-[1px] max-h-9'>
            <div className={`w-5 h-[17px] bg-gray-400 flex items-center ${disabled ? 'opacity-40 pointer-events-none cursor-not-allowed' : 'cursor-pointer'} justify-center ${modifiers.length - 1 === i && plusClass}`} onClick={() => !disabled && incrementFunc(addValue)}>
                <Plus size={12 - i} className='text-gray-100  ' disabled={true} />
            </div>
            <div className={`w-5 h-[18px] bg-gray-400 flex items-center justify-center ${disabled ? 'opacity-40 pointer-events-none cursor-not-allowed' : 'cursor-pointer'} ${modifiers.length - 1 === i && minusClass}`} onClick={() => !disabled && decrementFunc(minusValue)} >
                <Minus size={12 - i} disabled={true} className='text-gray-100 rotate-180 ' />
            </div>
        </div>)}

    </>
);

export default IRSUnit;
